import { Routes, Route, Navigate } from 'react-router-dom';
import { Spin } from 'antd';
import { useAuth } from './store/auth';
import { NotificationProvider } from './store/NotificationContext';
import MainLayout from './layouts/MainLayout';
import LoginPage from './pages/LoginPage';
import OidcCallbackPage from './pages/OidcCallbackPage';
import DashboardPage from './pages/DashboardPage';
import TasksPage from './pages/TasksPage';
import CalendarPage from './pages/CalendarPage';
import MeetingsPage from './pages/MeetingsPage';
import ChatPage from './pages/ChatPage';
import MyAccessPage from './pages/MyAccessPage';
import GuestsPage from './pages/GuestsPage';
import TalkPage from './pages/TalkPage';
import ReportsPage from './pages/ReportsPage';
import ActivityPage from './pages/ActivityPage';
import KSGPage from './pages/KSGPage';
import KSGWizardPage from './pages/KSGWizardPage';
import KSGDraftsPage from './pages/KSGDraftsPage';
import KSGDraftEditorPage from './pages/KSGDraftEditorPage';
import FAOPage from './pages/FAOPage';
import BPMPage from './pages/BPMPage';
import MailPage from './pages/MailPage';
import UsersPage from './pages/UsersPage';
import SupportPage from './pages/SupportPage';
import FeedPage from './pages/FeedPage';
import AdminPage from './pages/AdminPage';
import ExchangePage from './pages/ExchangePage';

import ProjectsPage from './pages/ProjectsPage';
import ProjectDetailsPage from './pages/ProjectDetailsPage';
import RegularMeetingsPage from './pages/RegularMeetingsPage';
import RegularMeetingDetailsPage from './pages/RegularMeetingDetailsPage';

function PrivateRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <Spin size="large" style={{ display: 'block', margin: '200px auto' }} />;
  return user ? <NotificationProvider>{children}</NotificationProvider> : <Navigate to="/login" />;
}

export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/login/callback" element={<OidcCallbackPage />} />
      <Route path="/" element={<PrivateRoute><MainLayout /></PrivateRoute>}>
        <Route index element={<DashboardPage />} />
        <Route path="projects" element={<ProjectsPage />} />
        <Route path="projects/:projectId" element={<ProjectDetailsPage />} />
        <Route path="tasks" element={<TasksPage />} />
        <Route path="calendar" element={<CalendarPage />} />
        <Route path="regular-meetings" element={<RegularMeetingsPage />} />
        <Route path="regular-meetings/:id" element={<RegularMeetingDetailsPage />} />
        <Route path="meetings" element={<MeetingsPage />} />
        <Route path="meetings/:meetingId" element={<MeetingsPage />} />
        <Route path="chat" element={<ChatPage />} />
        <Route path="access" element={<MyAccessPage />} />
        <Route path="guests" element={<GuestsPage />} />
        <Route path="talk" element={<TalkPage />} />
        <Route path="reports" element={<ReportsPage />} />
        <Route path="activity" element={<ActivityPage />} />
        <Route path="ksg" element={<KSGPage />} />
        <Route path="ksg/wizard" element={<KSGWizardPage />} />
        <Route path="ksg/drafts" element={<KSGDraftsPage />} />
        <Route path="ksg/drafts/:id" element={<KSGDraftEditorPage />} />
        <Route path="fao" element={<FAOPage />} />
        <Route path="bpm" element={<BPMPage />} />
        <Route path="mail" element={<MailPage />} />
        <Route path="users" element={<UsersPage />} />
        <Route path="support" element={<SupportPage />} />
        <Route path="feed" element={<FeedPage />} />
        <Route path="admin" element={<AdminPage />} />
        <Route path="exchange" element={<ExchangePage />} />
      </Route>
    </Routes>
  );
}
